// src/constants/storageKeys.ts
export const STORAGE_KEYS = {
  // 用户相关
  ACCESS_TOKEN: 'access_token', // 用户登录后授权的访问令牌（Access Token）
  TOKEN_KEY: 'token',
  REFRESH_TOKEN: 'refresh_token', // 用于刷新 Access Token 的令牌
  TOKEN_TYPE: 'token_type', // Token 类型（如 Bearer）
  EXPIRES_IN: 'expires_in', // Access Token 的过期时间（秒）
  EXPIRES_AT: 'expires_at',
  IS_LOGINED: 'is_logined',
  USER_INFO: 'user_info', // 用户基本信息（如 JSON 字符串，包含用户名、手机号等）
  USER_ID: 'user_id', // 用户唯一标识
  USER_ROLE: 'user_role', // 用户角色（如 admin, customer 等）
  USER_PREFERENCES: 'user_preferences', // 用户的个性化设置（如主题、语言等）
  USER_NAME: 'user_name',
  USER_AVATAR: 'user_avatar',
  USER_EMAIL: 'user_email',
  USER_PHONE: 'user_phone',
  CREATE_TIME: 'create_time',
  USER_NICKNAME: 'user_nickname',
  USER_GENDER: 'user_gender',
  SERVER_ID: 'server_id',

  LEVERAGES: 'leverages',
  // 金融账户相关
  SELECTED_ACCOUNT_ID: 'selected_account_id',
  ACCOUNT_BALANCE: 'account_balance', // 账户余额
  ACCOUNT_CURRENCY: 'account_currency', // 账户货币类型（如 USD, CNY）
  ACCOUNT_TYPE: 'account_type', // 账户类型（如储蓄账户、信用账户）
  LINKED_BANKS: 'linked_banks', // 用户绑定的银行信息
  TRANSACTION_LIMIT: 'transaction_limit', // 用户交易限额
  TRANSACTION_HISTORY: 'transaction_history', // 最近的交易记录（JSON 字符串）

  // 外汇
  ALL_FOREX_MAP: 'all_forex_map',
  // 投资相关
  PORTFOLIO_SUMMARY: 'portfolio_summary', // 投资组合概要信息
  STOCK_WATCHLIST: 'stock_watchlist', // 用户关注的股票列表
  FUND_PERFORMANCE: 'fund_performance', // 基金收益情况
  MARKET_NEWS: 'market_news', // 市场新闻和资讯
  RISK_ASSESSMENT: 'risk_assessment', // 用户风险评估结果（如保守型、激进型）

  // 应用设置
  APP_SETTINGS: 'app_settings',
  THEME: 'theme', // 应用主题设置（如 light, dark）
  LANGUAGE: 'language', // 应用语言（如 en, zh-CN）
  LANG: 'lang', // 语言设置（简化版）
  SESSION_TIMEOUT: 'session_timeout', // 用户会话超时时间（毫秒）
  ENABLE_BIOMETRIC: 'enable_biometric', // 是否启用生物识别（如指纹/面部解锁）
  LAST_LOGIN_TIME: 'last_login_time', // 用户最后登录时间（时间戳）

  // 安全相关
  MFA_ENABLED: 'mfa_enabled', // 是否启用多因素认证（如短信、邮箱）
  MFA_BACKUP_CODES: 'mfa_backup_codes', // 多因素认证的备用验证码
  FAILED_LOGIN_ATTEMPTS: 'failed_login_attempts', // 登录失败次数
  LAST_FAILED_LOGIN: 'last_failed_login', // 最近一次登录失败时间
  DEVICE_TRUST_LIST: 'device_trust_list', // 用户信任的设备列表（JSON 字符串）
  RECENT_NOTIFICATIONS: 'recent_notifications', // 最近的安全通知（如登录提醒、密码更改等）

  // 地区设置
  GEO_LOCATION: 'geo_location', // 用户的地理位置（如经纬度）
  TIMEZONE: 'timezone', // 用户的时区（如 UTC+8）
  USER_IP: 'userIp', // 用户IP地址
  USER_COUNTRY: 'userCountry', // 用户国家
  USER_COUNTRY_CODE: 'userCountryCode', // 用户国家代码
  USER_CITY: 'userCity', // 用户城市
  USER_STATE: 'userState', // 用户州/省
  LAST_FETCH_TIME: 'lastFetchTime', // 最后获取时间

  // 应用状态
  IS_LOGGED_IN: 'is_logged_in', // 用户是否已登录（布尔值）
  PENDING_ACTIONS: 'pending_actions', // 用户未完成的操作（如草稿、未提交订单等）
  ACTIVE_SESSION: 'active_session', // 当前活跃的会话 ID

  // 客户服务相关
  SUPPORT_CHAT_HISTORY: 'support_chat_history', // 用户与客服的聊天记录
  LAST_SUPPORT_REQUEST: 'last_support_request', // 最近一次客服请求的时间

  // 交易设置
  DEFAULT_PAYMENT_METHOD: 'default_payment_method', // 默认支付方式（如银行卡、支付宝）
  FAVORITE_BENEFICIARIES: 'favorite_beneficiaries', // 收藏的收款人列表
  TRANSACTION_DRAFTS: 'transaction_drafts', // 未提交的交易草稿
  LAST_TRANSACTION_ID: 'last_transaction_id', // 最近一次交易的 ID
  SOCKET_TOKEN: 'socket_token', // WebSocket认证token

  // 通用扩展
  APP_VERSION: 'app_version', // 当前应用版本
  DEVICE_ID: 'device_id', // 当前设备的唯一标识
  ANALYTICS_CONSENT: 'analytics_consent', // 用户是否同意数据分析/追踪
  PRIVACY_SETTINGS: 'privacy_settings', // 用户的隐私设置
  DEBUG_MODE: 'debug_mode', // 是否启用调试模式
  DARK_THEME: 'dark_theme',
  // 出金
  ENABLE_DYNAMIC_WITHDRAWAL: 'enable_dynamic_withdrawal',
}
